/**
 * StatCard - Card de estatística do Dashboard
 */
export default function StatCard({ index, type, icon, value, label, percentage }) {
  return (
    <div className={`stat-card ${type}`}>
      <div className="stat-card-head">
        <span className="stat-index" aria-hidden="true">{index}</span>
        <div className="stat-icon">
          <i className={`fas ${icon}`} />
        </div>
      </div>
      <div className="stat-content">
        <h3>{value}</h3>
        <p>{label}</p>
      </div>
      <div className="stat-percentage"><strong>{percentage}</strong><span>do total</span></div>
    </div>
  )
}
